//                                     BİSMİLLAHİRRAHMANİRRAHİM
//                                          ALLAHU  EKBER
//                                          ELHAMDÜLİLLAH


import React, {useState, useEffect} from 'react'
import {FaBars} from 'react-icons/fa'
import {QuestionContainer, QuestionInnerContainer, QuestionItem, RespondContainer, RespondInnerContainer, ResponseItem
, ResponseLogo, ResponseText, BackButtonIcon, BackContainer} from './QuestionElements';
import Language from '../../strings/index';
import detectLanguage from '../../common';
import { FaGithub } from "react-icons/fa";
import backButton from '../../icons/button.svg';

const Question = ({ toggle }) => {

    const [datas, setDatas] = useState(1);
    const [routes, setRoutes] = useState([]);
    // const [scrollNav, setScrollNav] = useState(false);
    // const [width, setWidth] = useState(window.innerWidth);

    // const changeNav = () => {
    //     if(window.scrollY >= 80){
    //         setScrollNav(true);
    //     }else{
    //         setScrollNav(false);
    //     }
    // }

    // const handleWindowSizeChange = () => {
    //     setWidth(window.innerWidth);
    // }

    // useEffect(() => {
    //     window.addEventListener('scroll', changeNav)
    //     window.addEventListener('resize', handleWindowSizeChange);
    //     console.log(isMobile)

    //     return () => {
    //         window.removeEventListener('resize', handleWindowSizeChange);
    //     }
    // }, []);

// let isMobile = (width <= 768);

    return (
        <>
        <QuestionContainer >
        <BackContainer>
                <BackButtonIcon hide={datas == 1 ? false : true} src={backButton} onClick={()=>{setDatas(routes.pop()); console.log(routes); setRoutes(routes);}}>

                </BackButtonIcon>
            </BackContainer>
            <QuestionInnerContainer>
                <QuestionItem>
                        {Language[datas].soru}
                </QuestionItem>
            </QuestionInnerContainer>

            <RespondContainer>
                <RespondInnerContainer>
                    {
                        Language[datas].cevaplar.map(({src, exist, cevap, route}) => (
                        <ResponseItem onClick={()=>{ if(route == 1) return; routes.push(datas); setRoutes(routes);setDatas(route);window.scrollTo({ top: 0, behavior: 'smooth' }); console.log(routes)}}>
                            <ResponseLogo src={src} exist={exist}/>
                            <ResponseText>
                                {cevap}
                            </ResponseText>
                        </ResponseItem>
                        ))
                    }
                </RespondInnerContainer>
            </RespondContainer>
           
        </QuestionContainer>
        </>
    )
};

export default Question
